module.exports = __webpack_public_path__ + "static/media/blue_card_bg_ar.30cd9519.png";